import { render, staticRenderFns } from "./GridText.vue?vue&type=template&id=19dcdd9c&scoped=true"
import script from "./GridText.vue?vue&type=script&lang=js"
export * from "./GridText.vue?vue&type=script&lang=js"
import style0 from "./GridText.vue?vue&type=style&index=0&id=19dcdd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dcdd9c",
  null
  
)

export default component.exports